import replaceImages, { Dimension, CanvasSizes } from './canvas';

export default function replaceProductImages() {
    const images = Array.from(document.querySelectorAll<HTMLImageElement>('img.js-product-canvas'));
    const config: CanvasSizes = {
        tile: {
            width: 360,
            height: 360,
            types: {
                'pot': {
                    size: 270,
                    dimension: Dimension.WIDTH,
                    position: [50, 100],
                },
                'tub-2550': {
                    size: 342,
                    dimension: Dimension.HEIGHT,
                    position: [50, 100],
                },
                'tub-6000': {
                    size: 360,
                    dimension: Dimension.HEIGHT,
                    position: [50, 100],
                },
                'tub-12000': {
                    size: 310,
                    dimension: Dimension.HEIGHT,
                    position: [50, 100],
                },
            },
        },
    };

    return replaceImages(images, config);
}
